<app-main-menu *ngIf="showMainMenu" [userRoles]="userRoles" (loginRequest)="loginRedirect()" [isLogged]="loginDisplay"></app-main-menu>
<div class="router-container">
    <router-outlet></router-outlet>
</div>
<app-loading></app-loading>
